import React from 'react';
import { SVGProps } from 'react';
interface SVGRProps {
  title?: string;
  titleId?: string;
}
/*
  README
  This is an automatically generated file and should not be edited manually.
  All changes should be made via 'make build-react-icons'
*/
const SvgFacebookLogo = ({
  title,
  titleId,
  ...props
}: SVGProps<SVGSVGElement> & SVGRProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={28}
    height={28}
    viewBox="0 0 28 28"
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path d="M26 14.045C26 7.392 20.628 2 14 2S2 7.392 2 14.045a12.048 12.048 0 0 0 9.103 11.691v-8.012H8.628v-3.68h2.475V12.46c0-4.098 1.847-5.999 5.86-5.999.759 0 2.071.15 2.61.301v3.331a15.768 15.768 0 0 0-1.387-.046c-1.969 0-2.728.748-2.728 2.69v1.309h3.919l-.675 3.679h-3.249V26C21.397 25.28 26 20.203 26 14.045Z" />
  </svg>
);
export default SvgFacebookLogo;
